import { dequal } from "dequal";
import { writable } from "../utils/stores";
import { notEq } from "../state/utils";
export function createSetStore(initialValue = new Set()) {
    let storeValue = initialValue;
    const store = writable(initialValue, undefined, notEq);
    store.subscribe((value) => (storeValue = value));
    return {
        subscribe: (subscriber, invalidate) => store.subscribe(subscriber, invalidate),
        set: (s) => {
            if (!dequal(s, storeValue)) {
                store.set(s);
            }
        },
        add: (id) => {
            if (!storeValue.has(id)) {
                store.update((ids) => {
                    ids.add(id);
                    return new Set(ids);
                });
                return true;
            }
            return false;
        },
        addMany: (newIds) => {
            const toAdd = newIds.filter((id) => !storeValue.has(id));
            if (toAdd.length > 0) {
                store.update((ids) => {
                    for (const id of toAdd) {
                        ids.add(id);
                    }
                    return new Set(ids);
                });
            }
        },
        delete: (id) => {
            if (storeValue.has(id)) {
                store.update((ids) => {
                    ids.delete(id);
                    return new Set(ids);
                });
                return true;
            }
            return false;
        },
        deleteMany: (ids) => {
            const toDelete = ids.filter((id) => storeValue.has(id));
            if (toDelete.length > 0) {
                store.update((ids) => {
                    for (const id of toDelete) {
                        ids.delete(id);
                    }
                    return new Set(ids);
                });
            }
        },
        clear: () => store.update((ids) => {
            ids.clear();
            return ids;
        }),
        get value() { return storeValue; },
    };
}
